module.exports = __webpack_public_path__ + "media/images/new/mobile/icons/twitter-b6b28d7415831b6a4ae859abb9a51ec8.png";